enum Side {
    Left = "left",
    Top = "top",
    Right = "right",
    Bottom = "bottom"
}

export default Side;
